<template>
  <div class="selfPhotoNotic-layout">
    <div class="read-ui" :class="{ selected: isReaded }" @click="handleNotice">
      <i></i>
      <div>
        <span>已阅读</span>
        <p @click="openNotic">《自营摄影服务协议》</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      isReaded: false
    }
  },
  computed: {
    ...mapState(['viewName'])
  },
  methods: {
    ...mapMutations(['changeView', 'setActionHeader']),
    handleNotice() {
      this.isReaded = !this.isReaded
      this.$emit('readChanged', this.isReaded)

      this.$$newTrackClick({
        bizType: '127',
        pageLevelId: '121013095',
        clickId: '200009'
      })
    },
    openNotic(event) {
      event.preventDefault()
      event.stopPropagation()

      this.setActionHeader({
        title: '通知',
        show: false
      })
      this.changeView('selfphotoNotice')
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })

      this.$$newTrackClick({
        bizType: '127',
        pageLevelId: '121013095',
        clickId: '200008'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.selfPhotoNotic-layout {
  height: rem(84px);
  background-color: #fff;

  padding: 0 rem(24px);
  @include border(bottom, #f2f2f2, 1px);
  .read-ui {
    line-height: 32px;
    height: 100%;
    display: flex;
    align-items: center;
    i {
      display: block;
      width: rem(52px);
      height: rem(40px);
      background-repeat: no-repeat;
      background-position: center left;
      background-size: rem(36px) auto;
      background-image: url('~@/assets/images/icon-raido-n@3x.png');
    }
    &.selected i {
      background-image: url('~@/assets/images/icon-单选框-选中@3x.png');
    }
    div {
      font-size: rem(26px);
      color: #666666;
      display: flex;
      align-items: center;
      p {
        display: block;
        color: #ff5900;
      }
    }
  }
}
</style>
